import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39a54a07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-bwn flex-ter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"14px","margin-right":"3px"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/echart_icon.png",
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "chat-history" }
const _hoisted_4 = { class: "chat-history-header" }
const _hoisted_5 = { class: "chat-history-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/close_icon_item.png",
  alt: "",
  style: {"width":"16px"}
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "chat-history-content" }
const _hoisted_9 = {
  key: 0,
  class: "chat-history-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex-bwn flex-ter" }
const _hoisted_12 = { class: "chat-history-item-title" }
const _hoisted_13 = { class: "chat-history-item-time" }
const _hoisted_14 = { class: "flex-bwn chat-history-item-content" }
const _hoisted_15 = { class: "content line--only" }
const _hoisted_16 = {
  key: 1,
  class: "empty"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "empty-img",
  src: "https://static-s.theckb.com/BusinessMarket/Client/echart_empty.png",
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "tips" }

import { computed, onMounted, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { CreateOrderChat, getVisitorTicketListResult, VisitorTicketListResultItem } from '@/util/useEchart';
import store, { useSite } from '@/store'
import axios from 'axios'
/**
 * bizType 1 订单 2国际物流
 */

export default /*#__PURE__*/_defineComponent({
  props: ['orderNo', 'metaData', 'companyId', 'list', 'title', 'bizType'],
  setup(__props) {

const props = __props

const popoverRef = ref()
const visible = ref(false)
const btnRef = ref<HTMLElement>()
const language = useSite()
/** 工单历史列表 */
const historyList = ref<VisitorTicketListResultItem[]>([])
/** 目前最新工单是否有对应的信息 */
const recordData = computed<VisitorTicketListResultItem>(() => {
  return props.list.find((item: VisitorTicketListResultItem) => JSON.stringify(JSON.parse(item.myData ?? '{}')) === decodeURIComponent(myData.value) && item.ticketStatus !== 6) ?? {}
})

const handlEchartHistoryClick = async () => {
  if (!visible.value) {
    const metaData = props.metaData
    const companyId = props.companyId
    const orderNo = props.orderNo
    const res: getVisitorTicketListResult = (await axios.get(`https://eapi.echatsoft.com/getVisitorTicketList?myData=${myData.value}&metaData=${encodeURIComponent(metaData)}&companyId=${companyId}`)).data
    if (res.successful) {
      historyList.value = res.result
    }
  }
  visible.value = !visible.value
}

const chartHistoryClose = () => {
  popoverRef.value.hide()
}
// 发起或者工单信息查看
const handlEchartClick = (e: Event, record: VisitorTicketListResultItem = recordData.value) => {
  const metaData = props.metaData
  const companyId = props.companyId
  const orderNo = props.orderNo
  const title = props.title
  const targetWin = new CreateOrderChat({
    url: record.myData ? record.ticketUrl : `https://www.echatsoft.com/visitor/pc/chat.html?metaData=${metaData}&companyId=${companyId}&lan=${language}&echatTag=web_${language}_${store.getters.plat}_job&myData=${myData.value}`,
    target: e.target as HTMLElement,
    type: record.myData ? 'preview' : 'create',
    height: 600,
    close: true,
    title,
    orderId: orderNo,
    imgUrl: 'https://static-s.theckb.com/BusinessMarket/Client/close_icon_item.png'
  })
}
const myData = computed(() => {
  const orderNo = props.orderNo
  let data = {}
  // 订单1 国际物流2参数请勿新增字段，否则会导致历史工单查询不到
  switch (props.bizType) {
    case 1:
      data = {
        platformOrderNo: orderNo,
        bizType: props.bizType
      }
      break
    case 2:
      data = {
        deliveryTaskCode: orderNo,
        bizType: props.bizType
      }
      break
  }
  return encodeURIComponent(JSON.stringify(data))
})

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_table_button, {
      warning: "",
      ref: (_value, _refs) => {
        _refs['btnRef'] = _value
        btnRef.value = _value
      },
      onClick: _withModifiers(handlEchartClick, ["stop"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_badge, {
            "is-dot": !!_unref(recordData).unRead,
            class: "item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('联系我们')), 1)
            ]),
            _: 1
          }, 8, ["is-dot"])
        ])
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_popover, {
      "popper-class": "chartPopover",
      ref: (_value, _refs) => {
        _refs['popoverRef'] = _value
        popoverRef.value = _value
      },
      trigger: "click",
      placement: "left",
      width: 480
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_table_button, {
          ref: (_value, _refs) => {
            _refs['btnRef'] = _value
            btnRef.value = _value
          },
          title: _unref(t)('工单历史1'),
          onClick: handlEchartHistoryClick
        }, null, 8, ["title"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.title) + ":" + _toDisplayString(__props.orderNo), 1),
            _createElementVNode("span", {
              class: "chat-history-close",
              onClick: chartHistoryClose
            }, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (historyList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "chat-history-item",
                      key: item.ticketId,
                      onClick: _withModifiers((e) => handlEchartClick(e, item), ["stop"])
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(item.ticketTitle), 1),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(item.ticketTime), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_el_avatar, {
                          size: 44,
                          src: "https://static-s.theckb.com/BusinessMarket/Client/echart_header.png"
                        }),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(item.ticketContent), 1)
                      ])
                    ], 8, _hoisted_10))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('暂无工单历史记录')), 1)
                ]))
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})